import React from "react";
import { Outlet } from "react-router-dom";

const StateRoot = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default StateRoot;
